module.exports = __webpack_public_path__ + "img/activity_fun1.2c4b516d.jpg";